import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import backend from "../../../../api";
import { Notification } from "../../../../utils";
import { useHistory, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import ClipLoader from "react-spinners/ClipLoader";
import { Helmet } from "react-helmet";
import useFormState from "../../../../utils/useFormState";  

const addGreeting = () => {
  const history = useHistory();
  const { pathname } = useLocation();
  const { user } = useSelector((state) => state.auth);
  const [greeting, setGreeting] = useState("");
  const [loading, setLoading] = useState(false);
  const [greet, setGreet] = useState([]);
  const { handleSubmit, register, errors, getValues } = useForm();

  const { formValues, handleChange, isButtonDisabled } = useFormState(
    { greeting: "" },
    { greeting: greet[0]?.greetings || "" } 
  );

  useEffect(() => {
    if (user) {
      if (!pathname.includes(user?.user?.role)) {
        history.replace(`/dashboard/${user?.user?.role}`);
      }
    }
  }, [user]);

  useEffect(() => {
    setLoading(true);
    if (user) {
      backend
        .get("/greetings", { params: { member: user.user._id } })
        .then(({ data }) => {
          setGreet(data.data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    }
  }, [user]);

  useEffect(() => {
    if (user && greet.length > 0) {
      setGreeting(greet[0].greetings);
    }
  }, [user, greet]);

  const editHandler = (e) => {
    e.preventDefault();
    const status = new Notification();
    backend
      .put(`/greetings/${greet[0]._id}`, { greetings: formValues.greeting }) 
      .then(({ data: { data, message } }) => {
        status.set_toast("success", message);
        setGreeting(data.greetings);
      })
      .catch((error) => {
        status.set_toast("error", error.response.data.message);
      })
      .finally(() => status.show_toast());
  };

  const submitHandler = () => {
    const data = getValues();
    const status = new Notification();
    const member = {
      ...data,
      member: user.user._id,
    };
    backend
      .post("/greetings", member)
      .then(({ data: { data, message } }) => {
        status.set_toast("success", message);
        setGreeting(data.greetings);
      })
      .catch((error) => status.set_toast("error", error.response.data.message))
      .finally(() => {
        status.show_toast();
      });
  };

  return (
    <>
      <Helmet>
        <title>eksplode! | Add Greeting</title>
      </Helmet>
      {loading ? (
        <div className="dashboard">
          <div className="box-account box-info mt-3">
            <div className="my-5 row justify-content-center">
              <ClipLoader color={"#000000"} loading={loading} size={60} />
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className="dashboard">
            <div className="box-account box-info">
              <div className="box-head">
                <h2>Add/Edit greetings for your EAC</h2>
              </div>
              <div className="row mt-3">
                <div className="col-lg-12 mx-auto register-page section-b-space">
                  <div className="theme-card">
                    <form className="theme-form">
                      <div className="form-row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="greeting">Greetings</label>
                            <textarea
                              type="text"
                              className="form-control mb-0"
                              id="greeting"
                              name="greeting"
                              value={formValues.greeting} 
                              placeholder="Enter greetings for your adcard"
                              onChange={(e) => {
                                handleChange(e);  
                              }}
                              ref={register({
                                required: {
                                  value: true,
                                  message: "This Field is Required",
                                },
                              })}
                            ></textarea>
                            <label htmlFor="greeting" className="error">
                              {errors.greeting && errors.greeting.message}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="row justify-content-end">
                        {greet.length > 0 ? (
                          <button
                            className="btn btn-solid ml-auto"
                            onClick={editHandler}
                            disabled={isButtonDisabled}  
                          >
                            Edit
                          </button>
                        ) : (
                          <button
                            className="btn btn-solid ml-auto"
                            onClick={handleSubmit(submitHandler)}
                            disabled={isButtonDisabled}  
                          >
                            Submit
                          </button>
                        )}
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default addGreeting;
